module.exports = __webpack_public_path__ + "media/frontend/svg/logo2-6d8490f84796e682aec79ac018d89489.svg";